import { INumberColorData } from "./interfaces";
import { Dictionary } from "lodash";

export const numberColorMap: Dictionary<INumberColorData> = {
    "#5077c7": { start: 0, end: 1.99 },
    "#9950c7": { start: 2, end: 9.99 },
    "#c34ed1": { start: 10, end: 99.99 },
    "#db4c8c": { start: 100, end: 199.99 },
    "#d62c5c": { start: 200, end: Infinity }
};
